// CONSTANTES BENEFICIOS //

export interface IAppBeneficios {
  entidades: { valor: number; descripcion: string }[];
}

export const AppBeneficios: IAppBeneficios = {
  entidades: [
    { valor: 0, descripcion: "Mutual" },
    { valor: 1, descripcion: "Obra Social" },
    { valor: 2, descripcion: "Sindicato" }
  ]
};

export interface IFrecuenciaBeneficios {
  frecuencia: { valor: number; descripcion: string }[];
}

export const frecuenciaBeneficios: IFrecuenciaBeneficios = {
  frecuencia: [
    { valor: 0, descripcion: 'Mensual' },
    { valor: 1, descripcion: 'Trimestral' },
    { valor: 2, descripcion: 'Semestral' },
    { valor: 3, descripcion: 'Anual' },
  ],
};

export interface TipoActividad {
  activo?: boolean;
  _id?: string;
  denominacion: string;
  imagen?: string;
  size?: number;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}


